// Masterclasses data loader — mirrors libraryFixtures.js.
//
// Reads the build-time `masterclasses.json` (produced by
// `scripts/sync-expressions.mjs` from the Airtable Masterclasses table,
// production_status = published). Used by:
//   • VideoAddEditPopUpCard — the optional `lessonKey` dropdown
//   • the lesson page — to label a video's linked masterclass
// Empty until the first sync runs; consumers handle the empty case.
import generated from './masterclasses.json';
import { bumpMirrorTick } from './mirrorCache';

const synced = Array.isArray(generated && generated.masterclasses)
  ? generated.masterclasses
  : [];

/** Published masterclasses: [{ id, name_ko, mc_type }]. */
export const MASTERCLASSES = synced;

/** id → { id, name_ko, mc_type } for O(1) lookup by Airtable record id. */
export const MASTERCLASS_BY_ID = new Map(synced.map((m) => [m.id, m]));

/** True when serving live synced data (vs. the empty pre-sync stub). */
export const IS_SYNCED_MASTERCLASSES = synced.length > 0;

/**
 * Replace the published masterclass set IN PLACE with live runtime data (the
 * Firestore mirror), rebuilding the id lookup. Mutates the existing array + Map
 * so consumers' references stay valid; no-op for an empty/invalid payload.
 * See docs/airtable-runtime-mirror-design.md.
 * @returns {boolean} true if hydrated, false if the payload was empty/invalid.
 */
export function hydrateMasterclasses(next) {
  if (!Array.isArray(next) || !next.length) return false;
  MASTERCLASSES.length = 0;
  MASTERCLASS_BY_ID.clear();
  for (const m of next) {
    MASTERCLASSES.push(m);
    MASTERCLASS_BY_ID.set(m.id, m);
  }
  bumpMirrorTick(); // see libraryFixtures — non-reactive store, ticked consumers
  return true;
}
